import React, { useEffect, useState } from "react";
import { Link, useOutletContext } from "react-router-dom";
import portalApi from "@/lib/portalApi";
import { ArrowRight, Building2 } from "lucide-react";

export default function PortalProjectsList() {
    const { me } = useOutletContext();
    const [projects, setProjects] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        portalApi.get("/portal/projects").then(({ data }) => {
            setProjects(data.items || []);
            setLoading(false);
        }).catch(() => setLoading(false));
    }, []);

    return (
        <div data-testid="portal-projects-page">
            <div className="mb-6">
                <div className="text-xs uppercase tracking-widest text-muted-foreground">Welcome back</div>
                <h1 className="text-2xl tracking-tight mt-1">{me?.display_name || me?.email}</h1>
                <p className="text-sm text-muted-foreground mt-1">Your accessible projects:</p>
            </div>

            {loading ? (
                <div className="text-sm text-muted-foreground">Loading projects…</div>
            ) : projects.length === 0 ? (
                <div className="border border-dashed border-border p-10 text-center" data-testid="portal-projects-empty">
                    <Building2 size={32} className="mx-auto mb-3 text-muted-foreground" />
                    <div className="text-sm">No projects assigned yet.</div>
                    <div className="text-xs text-muted-foreground mt-1">Contact the project team if you expect access.</div>
                </div>
            ) : (
                <div className="grid gap-3 md:grid-cols-2" data-testid="portal-projects-grid">
                    {projects.map((p) => (
                        <Link key={p.id} to={`/portal/projects/${p.id}`} className="border border-border p-4 hover:bg-secondary/40 transition-colors group" data-testid={`portal-project-card-${p.id}`}>
                            <div className="flex items-start justify-between">
                                <div>
                                    <div className="text-xs uppercase tracking-widest text-muted-foreground">{p.project_type?.replace(/_/g, " ")}</div>
                                    <div className="text-base font-medium tracking-tight mt-1">{p.name}</div>
                                    <div className="text-xs text-muted-foreground mt-1">{p.address}, {p.city}, {p.state}</div>
                                </div>
                                <ArrowRight size={14} className="opacity-30 group-hover:opacity-100 transition-opacity" />
                            </div>
                            <div className="mt-3 pt-3 border-t border-border flex items-center justify-between text-xs">
                                <span className="text-muted-foreground">Phase</span>
                                <span>{(p.current_phase_key || "—").replace(/_/g, " ")}</span>
                            </div>
                            <div className="mt-1 flex items-center justify-between text-xs">
                                <span className="text-muted-foreground">Progress</span>
                                <span>{Math.round(p.completion_pct || 0)}%</span>
                            </div>
                            {p.is_demo && (
                                <div className="mt-2 text-[10px] uppercase tracking-widest text-amber-600" data-testid={`demo-badge-${p.id}`}>Demonstration data</div>
                            )}
                        </Link>
                    ))}
                </div>
            )}
        </div>
    );
}
